var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.25C12.5 7.45435 12.8161 6.69129 13.3787 6.12868C13.9413 5.56607 14.7044 5.25 15.5 5.25H21.5C21.6989 5.25 21.8897 5.32902 22.0303 5.46967C22.171 5.61032 22.25 5.80109 22.25 6V18C22.25 18.1989 22.171 18.3897 22.0303 18.5303C21.8897 18.671 21.6989 18.75 21.5 18.75H15.5C14.7044 18.75 13.9413 19.0661 13.3787 19.6287C12.8161 20.1913 12.5 20.9544 12.5 21.75",
    stroke: "#0F1113",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 18C2.75 18.1989 2.82902 18.3897 2.96967 18.5303C3.11032 18.671 3.30109 18.75 3.5 18.75H9.5C10.2956 18.75 11.0587 19.0661 11.6213 19.6287C12.1839 20.1913 12.5 20.9544 12.5 21.75V8.25C12.5 7.45435 12.1839 6.69129 11.6213 6.12868C11.0587 5.56607 10.2956 5.25 9.5 5.25H3.5C3.30109 5.25 3.11032 5.32902 2.96967 5.46967C2.82902 5.61032 2.75 5.80109 2.75 6V18Z",
    stroke: "#0F1113",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/BookOpen.b46fa3a9a4d90590c21a6ecb4cd7e883.svg";
export { ForwardRef as ReactComponent };